import SalesmenContainer from "./containers/SalesmenContainer";

export default {
  path: "/salesmen",
  components: { main: SalesmenContainer, category: null }
};



// WEBPACK FOOTER //
// ./src/routes/Salesmen/index.js